<template>
	<!-- <div style="height: 100%; width: 100%;">  -->
	<div>
		<video ref="video" width="100%" height="100%" v-bind:poster="config.poster" controls playsinline></video>
	</div>
</template>
<script>
/* eslint-disable no-useless-escape */

import { log } from "@/logging";
import Hls from "hls.js";

const myLoggingName = "VideoJSPlayer";

// https://blog.logrocket.com/how-to-write-a-vue-js-app-completely-in-typescript/

export default {
	name: "VideoJSPlayer",
	props: {
		config: Object
	},
	mounted() {
		let stream = this.config.src;

		let video = this.$refs["video"];
		if (Hls.isSupported()) {
			let hls = new Hls();
			//let stream = "https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8";
			//let stream = "https://cdn3.wowza.com/1/Z1VlbkY0aVM3MDZV/cnRBYlpH/hls/live/playlist.m3u8";
			hls.loadSource(stream);
			hls.attachMedia(video);
			hls.on(Hls.Events.MANIFEST_PARSED, function() {
				video.play();
			});
		} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
			video.src = stream;
		}
		log(myLoggingName, "mounted exit");
	}
};
</script>
<style scoped lang="scss">
@import "../scss/constants";

.content {
	height: 600px;
}
</style>
